import { Modal } from "react-bootstrap"
import ButtonClose from "./ButtonClose"
import "./modal.css"

const ModalCobertura = (props) => {

    const handleClose = () => props.close(false)

    return (
        <>
             <Modal show={props.show} onHide={handleClose} size="lg" centered>
                <Modal.Body>
                    <ButtonClose close={handleClose} />
                    <div className='modal__groups'>
                        <div className="modal__group">
                            {/* <div className="cob__card-ico_container-mov-modal">
                                <img src={props.icon} alt="imagen cob icono" />
                            </div> */}
                            <div className="modal__descripcion">
                                <h3 className="modal__titulo">{props.titulo}</h3>
                                <div className="d-block d-lg-none pb-4"></div>
                                <p>{props.desc}</p>
                            </div>
                            <div className="modal__descripcion">
                                <h3>¿Qué no cubre tu seguro?</h3>
                                {
                                    props.coberturasDesc.length === 1 ? <p className="d-flex" dangerouslySetInnerHTML={{__html: props.coberturasDesc[0].descripcionCobertura}}></p>
                                    :
                                    <ul className="list__modal">
                                        {
                                            props.coberturasDesc && (
                                                props.coberturasDesc.map((desc, index) => {
                                                    return (
                                                        <li className="d-flex" dangerouslySetInnerHTML={{__html: desc.descripcionCobertura}}></li>
                                                    )
                                                })
                                            )
                                        }
                                    </ul>
                                }
                            </div>
                        </div>
                    </div>
                    <br/>
                    <br/>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalCobertura